import { createReducer } from 'by-react-utils'

type GlobalState = {
  +reset: boolean,
  +dock: boolean,
  +nofooter: boolean
}

export const initialState: GlobalState = {
  reset: false,
  dock: false,
  nofooter: false
}

export const ActionTypes = {
  RESET_SEARCH: 'RESET_SEARCH',
  LAYOUT: 'LAYOUT'
}

export default createReducer(initialState, {
  [ActionTypes.RESET_SEARCH]: (state) => ({
    ...state,
    reset: true
  }),
  [ActionTypes.LAYOUT]: (state, { dock, nofooter}) => ({
    ...state,
    dock,
    nofooter
  })
})



// WEBPACK FOOTER //
// ./src/store/reducers/Global.js